import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output, signal, ViewChild, WritableSignal } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CountableTimeZonePipe } from 'countable@helpers';
import { ToastrService } from 'ngx-toastr';
import { distinctUntilChanged, finalize, Subject, Subscription, takeUntil } from 'rxjs';
import { IExportData } from 'src/app/model/export-data.model';
import { ExportPlatformService } from 'src/app/services/export-platform.service';
import { CoreModule } from '../../../../core/core.module';
import { SharedModule } from '../../../shared/shared.module';

@Component({
    selector: 'app-user-export-all-data',
    templateUrl: './export-all-data.component.html',
    styleUrls: ['./export-all-data.component.scss'],
    providers: [CountableTimeZonePipe],
    standalone: true,
    imports: [SharedModule, CommonModule, CoreModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserExportAllDataComponent implements OnInit, OnDestroy {

  @Input() set clientCount(count: number) {
    this.client.set(count);
  }

  @Input() set engCount(count: number) {
    this.eng.set(count);
  }
    @Output() goBack = new EventEmitter<boolean>();
    @Output() spinnerConfig = new EventEmitter<boolean>(null);
    masterData: IExportData[] = [];
    columnDefs: any;
    public allSubscriptions = new Subscription();
    private readonly unSubscribe$: Subject<void> = new Subject<void>();
    displayedColumns: string[] = ['clientName', 'engagementType', 'engagementName', 'financialYearEndDate', 'partnerName'];
  public client: WritableSignal<number> = signal<number>(0);
  public eng: WritableSignal<number> = signal<number>(0);
    dataSource: MatTableDataSource<IExportData>;
    @ViewChild(MatSort) sort: MatSort;

    constructor(
        private exportPlatformService: ExportPlatformService,
        private toaster: ToastrService,
        private countableTimeZonePipe: CountableTimeZonePipe,
    ) { }
    ngOnInit() {
        this.columnDefs = {
            clientName: "Client Name",
            engagementType: "Engagement Type",
            engagementName: "Engagement ID",
            financialYearEndDate: "Year End",
            partnerName: "Partner",
        };
        this.getExportData();
    }

    getExportData() {
        this.spinnerConfig.emit(true);
        this.allSubscriptions.add(
            this.exportPlatformService.getExportData('regular').pipe(
                takeUntil(this.unSubscribe$),
                distinctUntilChanged(),
                finalize(() => this.spinnerConfig.emit(false))
            ).subscribe({
                next: (response: any) => {
                    if (response && response.data && response.data.length) {
                        response.data.forEach(ele => {
                            ele.financialYearEndDate = this.countableTimeZonePipe.transform(ele.financialYearEndDate, "MMM dd, yyyy", 'UTC');
                        });
                        this.masterData = JSON.parse(JSON.stringify(response.data));
                        this.dataSource = new MatTableDataSource(this.masterData);
                        this.dataSource.sort = this.sort;
                    } else {
                        this.masterData = [];
                    }
                },
                error: (error: any) => {
                    this.toaster.error(error.error);
                }
            })
        );
    }

    onBtnExport() {
        const copyData = JSON.parse(JSON.stringify(this.masterData));
        copyData.forEach(ele => {
            ele.financialYearEndDate = this.countableTimeZonePipe.transform(ele.financialYearEndDate, "YYYY-MM-DD");
        });
        this.exportPlatformService.exportData(copyData);
        //this.exportPlatformService.navigateToHistoryTab$.next(true);
    }

    goBackToExportData() {
        this.goBack.emit(true);
    }

    ngOnDestroy(): void {
        this.unSubscribe$.next();
        this.unSubscribe$.complete();
    }
}
